// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2508":"64f55e252df6cb01","2888":"f56af5266d97ec7b","4240":"5369f9e836bd5643"}[chunkId] + ".css";
};